// extracted by mini-css-extract-plugin
module.exports = {"default":"_99551c8aa8--default--P6yJA","light":"_99551c8aa8--light--TNQCA","outline":"_99551c8aa8--outline--ibgRB"};